import { gql } from '@apollo/client'

export const startCoursePurchase = gql`
  query StartCoursePurchase($courseId: String!, $url: String!) {
    startCoursePurchase(courseId: $courseId, url: $url)
  }
`
